import React, {useEffect, useReducer, useState} from 'react'
import UserReducer from './UserReducer'    //este componente contiene las funciones que queremos ejecutar
import UserContext from "./UserContext"
import axios from 'axios'
import { GET_PROFILE, GET_LOGIN} from '../types'
import jwt_token from 'jwt-decode';
import { getToken } from '../../helpers/helpers'
import { getDataList } from '../../api/common'


const UserState =(props) =>{
    // aqui almacenamos el estado del usuario
    const initialState ={
        user:null,
        userSelected:null
    }
    const token = getToken();

    const [userData, setUserData] = useState(null);
    const [preLogin, setPreLogin] = useState(null);
    const [ userSelected, setUserSelected] = useState(null);
    const [ message, setMessage] = useState(null);


      useEffect(()=>{

        async function getUserData(){
          try{
        const user = await jwt_token(token);
        let usuarioActualizado = user;
        try{
          // el token puede traer un role desactualizado si fue editado luego del login;
          // se refresca aqui para que un simple F5 refleje los permisos vigentes
          const resp = await getDataList('Usuarios', { conditions: { _id: user._id } });
          if (resp?.status === 200 && resp.data.data.length > 0) {
            usuarioActualizado = { ...user, role: resp.data.data[0].role };
          }
        }catch(error){
          //console.log(error)
        }
        setUserData(usuarioActualizado)
      }catch(error){
        //console.log(error)
      }
        }
        getUserData()
      },[setUserData,token])
      

      

    
      
    
      


    return(
        <UserContext.Provider value = {{
            setUserData,
            userData,
            userSelected, 
            setUserSelected,
            message,
            setMessage,
            preLogin,
            setPreLogin    
            }}>
            {props.children}            
        </UserContext.Provider>
    )
    // Props.children van a ser los componentes que van a estar dentro de Usercontext.provider
    // la propiedad value donde indicamos a que informacion pueden acceder los componentes que estan dentro
}

export default UserState; 


